// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_2osON","withHover":"_3zB05","name":"_3RceO","serviceInfo":"_16VTK","personInfo":"F5CLL","inline":"_2dkYy"};